import React, { Component } from 'react';
import HomeHeader from '../components/HomeHeader/HomeHeader';
import setStickyFooter from '../utils/stickyFooter';
import * as PageTitle from '../utils/titleSetter';

class Home extends Component {
	componentDidMount() {
		setStickyFooter();
		PageTitle.setPageTitle(PageTitle.pageNames.home, false);
	}
	render() {
		return (
			<div>
				<HomeHeader />
			</div>
		);
	}
}

export default Home;



/** WEBPACK FOOTER **
 ** ./src/pages/Home.js
 **/